import React, { Component } from 'react';
import { connect } from 'react-redux';

import PropTypes from 'prop-types';
import { toggleModal } from '../Modal/modalActions';
import { getIsUserAnAdmin } from '../UserData/userDataEntity';
import Users from './Users/Users';
import { getIsLoading as getIsUserLoading } from '../Self/selfEntity';
import { getAvailableRoles } from './userManagementActions';
import { EmvioButton } from '@nexio/emvio-form-components';
import './UserManagement.scss';

export class UserManagement extends Component {
    static propTypes = {
        isAdmin: PropTypes.bool,
        isUserLoading: PropTypes.bool,
        onAddNewUser: PropTypes.func.isRequired,
        getAvailableRoles: PropTypes.func.isRequired
    };

    constructor(props) {
        super(props);

        this.renderHeaderComponent = this.renderHeaderComponent.bind(this);
    }

    componentDidMount() {
        this.props.getAvailableRoles();
    }

    renderHeaderComponent() {
        return (
            <div className="header-container">
                <div className="header-text">
                    Users
                </div>
                <div className="button-container">
                    <EmvioButton
                        invertColors
                        size="small"
                        fullWidth
                        onClick={this.props.onAddNewUser}>
                        Add New User
                    </EmvioButton>
                </div>
            </div>
        );
    }

    render() {
        if (!this.props.isAdmin && !this.props.isUserLoading) {
            return (<div className="emvio-user-management">
                Insufficient access rights to manage users.
            </div>);
        }

        return (<div className="emvio-user-management">
            <Users renderHeaderComponent={this.renderHeaderComponent} />
        </div>);
    }
}

function mapStateToProps(state) {
    return {
        isAdmin: getIsUserAnAdmin(state),
        isUserLoading: getIsUserLoading(state)
    };
}

function mapDispatchToProps(dispatch) {
    return {
        onAddNewUser: () => dispatch(toggleModal('createUser', {})),
        getAvailableRoles: () => dispatch(getAvailableRoles())
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(UserManagement);
